import { useEffect, useState, Component } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";

import Intro from "./components/Intro";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FeaturedServices from "./components/FeaturedServices";
import Marquee from "./components/Marquee";
import Rooms from "./components/Rooms";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Tourism from "./components/Tourism";
import Testimonials from "./components/Testimonials";
import ThermalFeature from "./components/ThermalFeature";
import LocationSection from "./components/LocationSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#FFF9F6] p-8 text-center">
          <div>
            <p className="font-serif text-2xl text-[#40312F]">Algo salió mal.</p>
            <p className="mt-2 text-sm text-[#6E5A57]">Recargá la página para volver al inicio.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function Site() {
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-federasol-cream font-sans text-federasol-cocoa antialiased">
      <Intro onFinish={() => setIntroDone(true)} />
      <Header introDone={introDone} />
      <main>
        <Hero introDone={introDone} />
        <FeaturedServices />
        <Marquee />
        <Rooms />
        <Services />
        <Gallery />
        <Tourism />
        <Testimonials />
        <ThermalFeature />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp introDone={introDone} />
      <Toaster position="bottom-center" richColors closeButton />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <Site />
      </LanguageProvider>
    </ErrorBoundary>
  );
}
